'use client';

import React from 'react';
import { Box, Link } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import DynamicScrollHeader from '@components/DynamicScrollHeader';
import AldarLogo from '@components/AldarLogo';
import DynamicHideBlock from '@components/DynamicHideBlock';
import cn from './style.module.scss';
export default function LsqSodicHeader(props: MarketingPageComponentProps) {
  const headerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'header' && section.enabled
  );
  if (!headerSection) return null;
  return (
    <DynamicScrollHeader
      headerClassName={cn.sodicHeaderWrapper}
      scrolledClassName={cn.sodicHeaderScroll}
    >
      <Box className={cn.sodicHeaderInner}>
        <Box className={cn.sodicHeaderBlock}>
          <Box className={cn.sodicHeaderNavigation}></Box>
          <Box className={cn.sodicHeaderCompany}>
            <DynamicHideBlock data={headerSection?.lsqSodicHeaderAldar}>
              <Link
                href={'https://www.aldar.com/properties/en'}
                target={'_blank'}
                rel="noopener noreferrer"
                className={cn.sodicCompanyLogo}
              >
                <AldarLogo color="white" />
              </Link>
            </DynamicHideBlock>
          </Box>
        </Box>
      </Box>
    </DynamicScrollHeader>
  );
}
